import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

const TMPX_LOGS_ENDPOINT = "https://toolbox.synchromode.eu/scenarios/tmpx/plan-state/logs";

const TmpxLogsData = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(TMPX_LOGS_ENDPOINT, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      setData(response.data?.data || []);
    } catch (err) {
      setError(t("scenarios.tmpxLogs.loadError"));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};

export default TmpxLogsData;
